// MSYRT-169 - In rare cases the animation would not trigger. The logic for this animation is in the minimied javascript file. It's easier to rewrite the logic.
(function() {
  const REVEAL_CLASS = 'hdt-reveal-in-view';
  const REVEAL_SELECTOR = '[hdt-reveal]';
  const ANIMATION_END_ATTR = 'animationend';
  
  const observerOptions = {
    root: null,
    rootMargin: '0px 0px -10% 0px',
    threshold: 0.1
  };

  let intersectionObserver;

  function initRevealAnimations() {
    const revealElements = document.querySelectorAll(REVEAL_SELECTOR);
    
    if (revealElements.length === 0) {
      return;
    }

    intersectionObserver = new IntersectionObserver(handleIntersection, observerOptions);
    
    revealElements.forEach((element, index) => {
      element.style.setProperty('--animation-order', index);
      element.addEventListener('animationend', handleAnimationEnd);
      intersectionObserver.observe(element);
    });
  }

  function handleIntersection(entries) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add(REVEAL_CLASS);
        intersectionObserver.unobserve(entry.target);
      }
    });
  }

  function handleAnimationEnd(event) {
      const element = event.target;
      
      if (event.animationName === 'revealSlideIn' || event.animationName === 'reveaFadeIn') {
          element.setAttribute(ANIMATION_END_ATTR, '');
          element.removeEventListener('animationend', handleAnimationEnd);
    }
  }

  function init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initRevealAnimations);
    } else {
      initRevealAnimations();
    }
  }

  init();

  window.HDTReveal = {
    init: initRevealAnimations,
    REVEAL_CLASS: REVEAL_CLASS,
    REVEAL_SELECTOR: REVEAL_SELECTOR
  };
})();
